package dev.valvassori.minesweeper.model

enum class MarkType(val symbol: String) {
    NONE(""),
    FLAG("🚩"),
    QUESTION("❓"),
}
